import { render, staticRenderFns } from "./Waiting_invoice.vue?vue&type=template&id=542b9fb2&scoped=true"
import script from "./Waiting_invoice.vue?vue&type=script&lang=js"
export * from "./Waiting_invoice.vue?vue&type=script&lang=js"
import style0 from "./Waiting_invoice.vue?vue&type=style&index=0&id=542b9fb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542b9fb2",
  null
  
)

export default component.exports